import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Trans } from 'react-i18next';

import Button from 'components/Button';

import './InitialExtraQuestions.scss';

const InitialExtraQuestions = ({ initiateExtraQuestions }) => {
    return (
        <div className='container'>
            <h2>{i18n.t('engagement.congratulations')}</h2>

            <Trans i18nKey='engagement.overall_several_weeks_you_have_now' parent='p' />
            <Button text={ i18n.t('engagement.next') } className='cancel-button' onClick={ initiateExtraQuestions } width='120px' />
        </div>
    );
};

InitialExtraQuestions.propTypes = {
    initiateExtraQuestions: PropTypes.func
};

InitialExtraQuestions.defaultProps = {
    initiateExtraQuestions: null
};

export default InitialExtraQuestions;
